import { useState } from 'react';
import WarehouseCommonApi from '../../../API/warehouse/common-api';
import { TYPE_BUTTONS } from '../../../constans';
import { showSuccessNotify } from '../../../utils/Notiffication';
import plus from '../../../assets/media/icons/plus.svg';
import img_house from '../../../assets/media/icons/warehouse.svg';
import { Row } from '../../Basic/Blocks';
import { ButtonWithTooltip } from '../../Basic/Buttons';
import { Icon } from '../../Basic/Elements';
import { Input } from '../../Basic/Inputs';

const AddToWarehouseButton = ({
  id,
  isSource = false,
  isPair = false,
  onChangeWarehouse = () => { },
  onChangeProduct = () => { },
  onChangeEntry = () => { },
  num = 1,
  close = () => { },
  skladName,
}) => {
  const [stock, setStock] = useState(num);

  const add = async (s, newId = null) => {
    await WarehouseCommonApi.addToWarehouse({ data: { sku: id, quantity: parseInt(s), skladName } })
      .then((r) => {
        if (r.info === 'new') {
          showSuccessNotify(`Товар ${r.providerProduct.name} ${s} шт. добавлен на склад  `);
          setStock(0);
          console.log(r.warehouseProduct, r.providerProduct);

          onChangeWarehouse(r.warehouseProduct);
          onChangeProduct(r.providerProduct);
          onChangeEntry(r.entriedProduct);
          close();
          return;
        }
        if (r.info === 'exists') {
          showSuccessNotify(
            `Товар ${r.providerProduct.name} ${s} шт. добавлен на склад. Всего на складе ${r.providerProduct.remains}`,
          );
          setStock(0);
          onChangeWarehouse(r.warehouseProduct);
          console.log(r.warehouseProduct, r.providerProduct);
          onChangeProduct(r.providerProduct);
          onChangeEntry(r.entriedProduct);

          close();
        }
      })
      .catch();
  };

  return (
    <Row>
      <Input value={stock} onChange={(v) => setStock(v)} style={{ width: '40px' }} center />
      <ButtonWithTooltip
        tooltip="Добавить на склад"
        onClick={() => add(stock)}
        style={{ marginLeft: '15px', padding: '10px', width: '50px' }}
        type={TYPE_BUTTONS.WHITE}
        disabled={stock <= 0}
      >
        <Icon src={isSource || isPair ? plus : img_house} width={isSource ? 20 : 30} />
      </ButtonWithTooltip>
    </Row>
  );
};

export default AddToWarehouseButton;
